import { usePathname } from 'next/navigation'
import AnimationScroll from './animationScroll'
import AnimationLottie from './animationLottie'
import ButtonDefault from './buttonDefault'

const LogoButtonAnimation = ({ scrolled, onAnimationComplete }) => {
  const pathname = usePathname()

  if (pathname === '/') {
    return (
      <div id="headerAnimation" className="absolute top-0 left-0 w-full h-[100svh] pointer-events-none">
        <AnimationScroll
          scrolled={scrolled}
          onAnimationComplete={onAnimationComplete}
        />
        <AnimationLottie />
      </div>
    )
  }
  return <ButtonDefault />
}

export default LogoButtonAnimation
